import { patchAsync as _patchAsync, add as _add, deleteAllAsync as _deleteAllAsync } from "../../api";

const BASE_URL = "/coc/requests";

export function add({ payload, onSuccess, onError }) {
    _add({ url: `${BASE_URL}/${payload.requestId}/evidences`, data: payload, onSuccess, onError });
}

export async function markEvidenceAsReceivedAsync(requestId, evidenceId) {
    return _patchAsync({ url: `${BASE_URL}/${requestId}/evidences/${evidenceId}:mark-as-received` });
}

export async function unmarkEvidenceAsReceivedAsync(requestId, evidenceId) {
    return _patchAsync({ url: `${BASE_URL}/${requestId}/evidences/${evidenceId}:unmark-as-received` });
}

export async function changeEvidenceStatusAsync(requestId, evidenceId, status) {
    return _patchAsync({ url: `${BASE_URL}/${requestId}/evidences/${evidenceId}:change-status`, data: status });
}

export async function requestToClientAsync(requestId, evidenceId) {
    return _patchAsync({ url: `${BASE_URL}/${requestId}/evidences/${evidenceId}:request-to-client` });
}

export async function unrequestToClientAsync(requestId, evidenceId) {
    return _patchAsync({ url: `${BASE_URL}/${requestId}/evidences/${evidenceId}:unrequest-to-client` });
}

export async function deleteAsync(requestId, evidenceId) {
    return _deleteAllAsync({ url: `${BASE_URL}/${requestId}/evidences`, data: { ids: [evidenceId] } });
}